import * as $ from "jquery";
import * as _ from "underscore";
import * as globalConfig from "globalConfig";

export namespace ConfigurableTextService {
    const ConfigurableTextCacheDetails = {} as any;

    export function RetrieveTextSync(stockTextKey: string, locationId: number = null): string {
        let stockText = null as string;

        RetrieveText(stockTextKey, false, locationId)
            .done((response: string) => {
                stockText = response;
            });

        return stockText;
    }

    export function RetrieveTextAsync(stockTextKey: string, locationId: number = null): Promise<string> {
        return new Promise((resolve, reject) => {
            RetrieveText(stockTextKey, true, locationId)
                .then(resolve)
                .fail(reject);
        });
    }

    export function SetTextAsync(stockTextKey: string, callback: any, locationId: number = null): void {
        RetrieveText(stockTextKey, false, locationId)
            .then((response: string) => {
                callback(response);
            });
    }


    type StringDictionary<T> = { [key:string] : T }
    export function RetrieveBulkTextAsync(stockTextKeys: Array<string>, locationId: number = null): Promise<StringDictionary<string>> {
        const op = RetrieveText(stockTextKeys.join(';'), true, locationId);

        var promise = new Promise((done, reject) => {
            op.then(done).fail(reject)
        });

        return promise.then((data) => {
            var output: StringDictionary<string> = {};

            _.each(data, (value, key) => {
                output[key] = value;
            })

            return output;
        });
    }

    //This method can't currently be converted over to native promises due to the comment below and the use of non-async code in this method via the isAsync flag.
    function RetrieveText(stockTextKey: string, isAsync = false, locationId: number = null): JQueryDeferred<string> {
        let key = `${stockTextKey}-ASYNC-${isAsync}`;

        let url = globalConfig.Urls.ConfigurableText.Get
            .replace("{macroName}", stockTextKey);

        if (locationId) {
            url += `?locationId=${locationId}`;
            key += `-locationId-${locationId}`;
        }

        if (!ConfigurableTextCacheDetails[key]) {
            // Important    :   We shouldn't really be doing any synchronous calls via an AJAX request, all of them should be
            //                  asynchronous. v1.8 of jQuery deprecated this when dealing with deferred called using the `then`
            //                  callback. The only way to get around this in v3.* and onwards is to use `done` instead, however
            //                  this goes against the promise pipeline and standards. At some point in the future this is going
            //                  to need refactoring to be fully asyncronous.
            // Source       :   https://jquery.com/upgrade-guide/3.0/#callback-invocation
            ConfigurableTextCacheDetails[key] = $.ajax({
                type: "GET",
                url: url,
                dataType: "JSON",
                async: isAsync,
                cache: true
            });
        }

        return ConfigurableTextCacheDetails[key];
    }
}